module.exports = __webpack_public_path__ + "img/chick_sale_infographic.dff482d2.svg";